module.exports = __webpack_public_path__ + "static/media/icon-pipelines-grey.e95bbf25.svg";